function collectionHas(a, b) { // helper function (see below)
  for (var i = 0, len = a.length; i < len; i++) {
    if (a[i] == b) return true;
  }
  return false;
}
export default function findParentBySelector(elm, selector) {
  var all = document.querySelectorAll(selector);
  var cur = elm.parentNode;
  while (cur && !collectionHas(all, cur)) { // keep going up until you find a match
    cur = cur.parentNode; // go up
  }
  return cur; // will return null if not found
}

export async function getCurrentDistrict() {
  const districtUrl = `${process.env.API_URL}/eservices/get_current_district/`;
  const r = await fetch(districtUrl);
  const resp = await r.json();
  return resp.teryt;
}

export const removeChildNode = (parentNode, childNodeClass) => {
  const chNodes = parentNode.childNodes;
  const chNodesArray = [...chNodes];
  const chNodeIndex = chNodesArray.findIndex(item => item.classList.contains(childNodeClass));
  // if (parentNode.childNodes[indexToRemove]) { parentNode.childNodes[indexToRemove].remove(); }
  if (parentNode.childNodes[chNodeIndex]) { parentNode.childNodes[chNodeIndex].style.display = 'none'; }
};

export const headerStyle = {
  normal: {
    backgroundColor: '#31485e',
    color: 'white',
  },
  intenseBlack: {
    backgroundColor: 'black',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: 'black',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'black',
    color: 'yellow',
  },
};

export const layoutColorStyle = {
  normal: {
    backgroundColor: '#f2f2f2',
    color: 'black',
  },
  intenseBlack: {
    backgroundColor: '#111212',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: '#111212',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'yellow',
    color: 'black',
  },
};

export const getThemeFromLocalStorage = () => {
  const cookie = localStorage.getItem('colorTheme') || 'normal';
  return cookie;
};



// WEBPACK FOOTER //
// src/components/utils/utils.js